import { useEffect } from "react";
import "components/Payment/payment.scss";
import CartInfo from "components/Customize/CartInfo";
import { useWrapRequest } from "utils";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { toastState, cartState, mobileRegistryModalState } from "atoms";
import { getPaymentPage } from "services/get-paymentPage";
import PaymentForm from "components/Payment/PaymentForm";
import { Modal } from "react-bootstrap";

const Payment = () => {
  const wrapRequest = useWrapRequest();
  const navigate = useNavigate();
  const [toast, setToast] = useRecoilState(toastState);
  const [cart, setCart] = useRecoilState(cartState);
  const [showMobileRegistryModal, setShowMobileRegistryModal] = useRecoilState(mobileRegistryModalState);

  useEffect(() => {
    wrapRequest(async () => {
      const getPaymentPageResponse = await getPaymentPage();
      const links = getPaymentPageResponse["_links"];
      const windowLocation = "ec:windowLocation";

      if (getPaymentPageResponse._embedded) {
        const cart = getPaymentPageResponse._embedded["ec:cart"];
        setCart(cart);

        if (getPaymentPageResponse["message"]) {
          setToast({
            ...toast,
            show: true,
            variant: "danger",
            header: "Error",
            message: `${getPaymentPageResponse["message"]}`,
          });
        }
      } else {
        navigate(links[windowLocation].href);
      }
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const handleSubmit = () => {
    return false;
  };
  return (
    <div className="payment-container w-100">
      <h1 className="page-component-title">Payment</h1>
      <hr />
      <div className="d-flex">
        <div className="me-3 flex-grow-1">
          <div className="d-flex">
            <div className="what-iam-paying">
              <strong>What am I paying today?</strong>
            </div>
            <div className="amount-due">${cart.totalAmountDue}</div>
          </div>
          <hr />
          {Object.keys(cart).length > 0 ? <PaymentForm cart={cart} /> : null}
        </div>
        <div className="cart-registry">{Object.keys(cart).length > 1 ? <CartInfo cart={cart} onContinue={handleSubmit} /> : null}</div>
        <Modal show={showMobileRegistryModal} onHide={() => setShowMobileRegistryModal(false)}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>{Object.keys(cart).length > 1 ? <CartInfo cart={cart} onContinue={handleSubmit} /> : null}</Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Payment;
